import React from 'react';
import { Text } from '@zillow/constellation';
import ExperianTac from '../../../../constants/terms/ExperianTac';
import ExperianPp from '../../../../constants/terms/ExperianPp';
import CicTac from '../../../../constants/terms/CicTac';
import CicTacNew from '../../../../constants/terms/CicTacNew';
import { TermType } from '@zg-rentals/ts-id-verification-client';

function getHtml({ termType, currentVersion }: { termType: TermType; currentVersion?: number }): string {
  switch (termType) {
    case TermType.EXPERIAN_TAC:
      return ExperianTac;
    case TermType.EXPERIAN_PRIVACY_POLICY:
      return ExperianPp;
    case TermType.CIC_TAC:
      return currentVersion === 3 ? CicTacNew : CicTac;
    default:
      return '<div />';
  }
}
export default function TermsHtml({ termType, currentVersion }: { termType: TermType; currentVersion?: number }) {
  const html = getHtml({ termType, currentVersion });
  return (
    <Text
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}
